import { WRAPPED_RICH_EDITOR_METHODS, RICH_EDITOR_REFERENCE_NAME } from '../input-components.const';
import RichTextBox from '@/components/common/RichTextBox/RichTextBox';

export default {
	components: { RichTextBox },
	computed: {
		RICH_EDITOR_REFERENCE_NAME() {
			return RICH_EDITOR_REFERENCE_NAME;
		},
	},
	methods: {
		// wraps to use RichTextBox methods
		...WRAPPED_RICH_EDITOR_METHODS.reduce(
			(wrappedRichEditorMethods, richEditorMethod) => ({
				...wrappedRichEditorMethods,
				[richEditorMethod](...args) {
					this.$refs[this.RICH_EDITOR_REFERENCE_NAME][richEditorMethod](...args);
				},
			}),
			{}
		),
	},
};
